import React, { useState, useEffect } from "react";
import GlobalHelmet from "./../../GlobalHelmet";
import { makeStyles } from "@material-ui/core/styles";
import Loader from "./../../component/Loader";
import RestService from "./../../Restservice";
import Breadcrumbs from "./../../component/breadcrumbs";
import Chart from "./Chart";
import Select from "react-select";
import DialogContentText from "@material-ui/core/DialogContentText";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Common from "./../../common.json";
import ReactHtmlParser from "react-html-parser";

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  select: {
    width: "200px",
  },
}));

export default function Index() {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);
  const [sectorid, setsectorid] = useState(0);
  const [ntime, setntime] = useState(false);
  const [portfolioid, setportfolioid] = useState(0);
  const [formopen, setFormopen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [exitData, setexitData] = React.useState(false);
  const [stockOpt, setstockOpt] = useState(0);
  const [symbol, setsymbol] = useState("");
  const [showStatus, setShowStatus] = useState(-1);

  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";

  useEffect(() => {
    setLoading(true);
    RestService.getPortfolioAnalysisList(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data);
        if (response.data.status !== 0) {
          if (portfolioid === 0) {
            setportfolioid(response?.data?.portfolio_id);
          }
          if (sectorid === 0) {
            setsectorid(response?.data?.sectorData[0]["id"]);
          }
        }
        setShowStatus(response.data.status);
      },
      mobile,
      web_token,
      portfolioid
    );
  }, [ntime, mobile, web_token, portfolioid]);

  function refreshItem(event) {
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }

  function getPortfolioid(event) {
    setportfolioid(event.value);
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }

  function filterDataWithSecotr(event) {
    setsectorid(event);
  }

  const handleClose = () => {
    setFormopen(false);
  };
  const handlerClose = () => {
    setOpen(false);
  };

  const handleFormOpen = (e) => {
    setLoading(true);
    setstockOpt(0);
    RestService.getPortfolioExitList(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        if (response.data.status === 1) {
          setexitData(response.data.resultdata);
        } else {
          setexitData(false);
        }
        setFormopen(true);
      },
      mobile,
      web_token,
      5
    );
  };
  const handleStockOption = (e) => {
    setstockOpt(1);
  };
  const getStockFilter = (type) => {
    setLoading(true);
    RestService.getPortfolioExitList(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        if (response.data.status === 1) {
          setexitData(response.data.resultdata);
        } else {
          setexitData(false);
        }
        setFormopen(true);
      },
      mobile,
      web_token,
      type
    );
  };
  const handleDelete = (res) => {
    setsymbol(res.symbol);
    setOpen(true);
  };
  const handleAgree = (res) => {
    setLoading(true);
    RestService.deletePortfolioStock(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        if (response.data.status === 1) {
          setexitData(response.data.resultdata);
        } else {
          setexitData(false);
        }
        setOpen(false);
      },
      mobile,
      web_token,
      symbol
    );

    //setOpen(false);
  };

  return (
    <>
      {loading ? <Loader /> : ""}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Remove Symbol"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure want to remove this Symbol?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handlerClose} color="primary">
            Disagree
          </Button>
          <Button onClick={handleAgree} color="primary" autoFocus>
            Agree
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        maxWidth="lg"
        open={formopen}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {stockOpt === 1 ? "Add Stock" : " Exit Stock"}
          <button
            className="btn btn-default remove-stock-btn"
            onClick={handleClose}
          >
            <i className="fa fa-remove"></i>
          </button>
        </DialogTitle>
        <DialogContent>
          {stockOpt === 0 && (
            <>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Symbol</th>
                    <th>LTP</th>
                    <th>1 D</th>
                    <th>1 W</th>
                    <th>1 M</th>
                    <th>Signal</th>
                    <th>Portfolio Name</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {exitData &&
                    exitData.map((item, key) => (
                      <tr key={key}>
                        <td>{item.symbol}</td>
                        <td>{item.l}</td>
                        <td className={item.cp < 0 ? "txtRed" : "txtGreen"}>
                          {item.cp}
                        </td>
                        <td
                          className={item.weekpers < 0 ? "txtRed" : "txtGreen"}
                        >
                          {item.weekpers}
                        </td>
                        <td
                          className={
                            item.onemonthrs < 0 ? "txtRed" : "txtGreen"
                          }
                        >
                          {item.onemonthrs}
                        </td>
                        <td>{item.signal}</td>
                        <td>{item.portfolioName}</td>
                        <td>
                          <button
                            className="btn btn-danger"
                            onClick={() => handleDelete(item)}
                          >
                            <i className="fa fa-remove"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </>
          )}
          {stockOpt === 1 && (
            <>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Symbol</th>
                    <th>LTP</th>
                    <th>1 D</th>
                    <th>1 W</th>
                    <th>1 M</th>
                    <th>Signal</th>
                  </tr>
                </thead>
                <tbody>
                  {exitData &&
                    exitData.map((item, key) => (
                      <tr key={key}>
                        <td>{item.symbol}</td>
                        <td>{item.l}</td>
                        <td className={item.cp < 0 ? "txtRed" : "txtGreen"}>
                          {item.cp}
                        </td>
                        <td
                          className={item.weekpers < 0 ? "txtRed" : "txtGreen"}
                        >
                          {item.weekpers}
                        </td>
                        <td
                          className={
                            item.onemonthrs < 0 ? "txtRed" : "txtGreen"
                          }
                        >
                          {item.onemonthrs}
                        </td>
                        <td>{item.signal}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </>
          )}
        </DialogContent>
      </Dialog>

      <GlobalHelmet {...Common?.portfolioAnalysis} />

      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <div className="fixedAddButton">
                <Link
                  className="btn btn-success mr-1"
                  title="Check Performance"
                  to={"/portfolio-analysis/performance"}
                >
                  Check Performance
                </Link>
                <button className="btn btn-success" onClick={refreshItem}>
                  <i className="fa fa-refresh"></i>
                </button>
              </div>
              <Breadcrumbs page="Portfolio Analysis" addon="addon" />

              <div className={classes.root}>
                <div className="row profileCOntainer">
                  <div className="col-sm-3">
                    <label className="robo-suggestion">Robo Suggestion</label>
                  </div>
                  <div className="col-sm-9 text-right">
                    <button
                      onClick={handleFormOpen}
                      className="btn btn-danger"
                      disabled={showStatus > 0 ? "" : "disabled"}
                    >
                      Exit Stock
                    </button>
                    <button
                      onClick={handleStockOption}
                      className="btn btn-success"
                      disabled={showStatus > 0 ? "" : "disabled"}
                    >
                      Add Stock
                    </button>
                    <button
                      onClick={(event) => getStockFilter(1)}
                      style={{
                        display: stockOpt === 1 ? "inline-block" : "none",
                      }}
                      className="btn btn-success"
                      disabled={showStatus > 0 ? "" : "disabled"}
                    >
                      2 Weeks
                    </button>
                    <button
                      onClick={(event) => getStockFilter(2)}
                      style={{
                        display: stockOpt === 1 ? "inline-block" : "none",
                      }}
                      className="btn btn-success"
                      disabled={showStatus > 0 ? "" : "disabled"}
                    >
                      1 Month
                    </button>
                    <button
                      onClick={(event) => getStockFilter(3)}
                      style={{
                        display: stockOpt === 1 ? "inline-block" : "none",
                      }}
                      className="btn btn-success"
                      disabled={showStatus > 0 ? "" : "disabled"}
                    >
                      3 Months
                    </button>
                    <button
                      onClick={(event) => getStockFilter(4)}
                      style={{
                        display: stockOpt === 1 ? "inline-block" : "none",
                      }}
                      className="btn btn-success"
                      disabled={showStatus > 0 ? "" : "disabled"}
                    >
                      6 Months
                    </button>
                    {showStatus > 0 ? (
                      <Link
                        className="btn btn-success "
                        to="/portfolio-analysis/profile"
                      >
                        Profile
                      </Link>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-3 ">
                    {globaldata.portfolio && (
                      <>
                        <Chart sectorData={globaldata.sectorData} />
                      </>
                    )}
                  </div>
                  <div className="col-sm-1"></div>
                  <div className="col-sm-8 pl-4 pt-4">
                    {globaldata.portfolio && (
                      <>
                        <Select
                          Value={portfolioid}
                          onChange={getPortfolioid}
                          options={
                            globaldata.portfolio ? globaldata.portfolio : []
                          }
                          className={classes.select}
                        />
                        <table className="table mt-4">
                          <thead>
                            <tr>
                              <th>Sectors Allocations</th>
                              <th>Sectors Performations</th>
                            </tr>
                          </thead>
                          <tbody>
                            {globaldata.sectorData &&
                              globaldata.sectorData.map((item, key) => (
                                <tr key={key}>
                                  <td>
                                    <button
                                      href="#"
                                      className="hyperLink btn btn-default"
                                      onClick={(event) =>
                                        filterDataWithSecotr(item.id)
                                      }
                                    >
                                      {item.title} ({item.per}%)
                                    </button>
                                  </td>
                                  <td>
                                    {item.upstocks >= 70 ? (
                                      <i
                                        className="pl-4 fa fa-arrow-up txtGreen"
                                        aria-hidden="true"
                                      ></i>
                                    ) : (
                                      ""
                                    )}
                                    {item.upstocks >= 50 &&
                                    item.upstocks < 70 ? (
                                      <i
                                        className="pl-4 fa fa-exchange"
                                        aria-hidden="true"
                                      ></i>
                                    ) : (
                                      ""
                                    )}
                                    {item.upstocks < 50 ? (
                                      <i
                                        className="pl-4 fa fa-arrow-down txtRed"
                                        aria-hidden="true"
                                      ></i>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </>
                    )}
                  </div>
                </div>
                <div className="clear-fix mb-4"></div>
                {globaldata.portfolio && (
                  <div className="row mt-4">
                    <div className="col-sm-12 mt-4">
                      <table className="table tablr-bordered">
                        <thead>
                          <tr>
                            <th>Symbol</th>
                            <th>LTP</th>
                            <th>1D</th>
                            <th>1W</th>
                            <th>1M</th>
                          </tr>
                        </thead>
                        {globaldata.sectorData &&
                        globaldata.sectorData.length > 0 ? (
                          globaldata.sectorData.map((item, key) => (
                            <tbody
                              key={key}
                              style={{
                                display:
                                  sectorid === item.id
                                    ? "table-row-group"
                                    : "none",
                              }}
                            >
                              {item.child.map((items, keys) => (
                                <tr key={keys}>
                                  <td>{items.symbol} </td>
                                  <td>{items.ltp}</td>
                                  <td
                                    className={
                                      items.cp < 0 ? "redTxt" : "greenTxt"
                                    }
                                  >
                                    {items.cp}
                                  </td>
                                  <td
                                    className={
                                      items.weekpers < 0 ? "redTxt" : "greenTxt"
                                    }
                                  >
                                    {items.weekpers}
                                  </td>
                                  <td
                                    className={
                                      items.onemonthpers < 0
                                        ? "redTxt"
                                        : "greenTxt"
                                    }
                                  >
                                    {items.onemonthpers}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          ))
                        ) : (
                          <tbody>
                            <tr>
                              <td colSpan="5" className="text-center">
                                <p>No data is available.</p>
                              </td>
                            </tr>
                          </tbody>
                        )}
                      </table>
                    </div>
                    {globaldata.notes && (
                      <div className="col-sm-12 mt-4">
                        <p className="notes">
                          <b>Notes:</b> {ReactHtmlParser(globaldata.notes)}
                        </p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
